"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_UPLOAD = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.CREATE_UPLOAD = (0, gql_1.gql)(`
  mutation createUpload($name: String!) {
    upload(name: $name) {
      id
      urls {
        read write
      }
    }
  }
`);
